interface PawnProps {
  className?: string;
  /** Hop in place, e.g. while something loads. */
  hopping?: boolean;
  color?: "gold" | "duel" | "mint" | "cream";
}

const COLORS = {
  gold: "bg-gold",
  duel: "bg-duel",
  mint: "bg-mint",
  cream: "bg-cream",
} as const;

/** The player's game piece on the board. */
export function Pawn({
  className = "w-11 h-11",
  hopping = false,
  color = "gold",
}: PawnProps) {
  return (
    <span
      aria-hidden="true"
      className={`block rounded-[50%_50%_50%_50%/60%_60%_40%_40%] border-[3px] border-ink shadow-board-sm ${COLORS[color]} ${hopping ? "board-hop" : ""} ${className}`}
    />
  );
}
